/*
* Size (width x height) of each photo in public/images/photos, so the page can reserve its space before it loads.
* Add a line here when adding a new photo.
*/
export const PHOTO_SIZES = {
  "874ea7fa": [2400, 1594],
  "7b8e0883": [2400, 1600],
  "4f113ca7": [2400, 1594],
  "292a1026": [1080, 1350],
  "e8ea573d": [1080, 1080],
  "8818c43b": [1080, 1350],
  "8bd7c181": [1080, 1080],
  "1955f86a": [2400, 3000],
  "27d7c0a5": [2400, 1600],
  "c26930d4": [2400, 1600],
  "6de26e76": [2400, 3360],
  "4e447e8a": [2400, 1593],
  "5f209e8d": [2400, 1594],
  "1b4dbef3": [1080, 1080],
  "92cd544e": [2400, 1593],
  "f35628cf": [2400, 1593],
  "7a420e20": [1080, 1350],
  "4e6b14e7": [1080, 1350],
  "a176e8b8": [1080, 1350],
  "f28ab1ae": [1080, 1080],
  "e4fdc89d": [1080, 1080],
  "60b536a6": [1080, 1350],
  "7302fe89": [2400, 1594],
  "d0b34e9e": [2400, 1600],
  "4b0c69d7": [1080, 1080],
  "9b16bc06": [1080, 1080],
  "ffc059a2": [1080, 1350],
  "ad8610e6": [1080, 1350],
  "2a574ede": [1080, 1350],
  "70386349": [1080, 1350],
  "17a1d502": [2076, 1375],
  "ed88c11b": [2074, 1378],
  "cd4a9f55": [2400, 1594],
  "ce9cdb8c": [1080, 1350],
  "9f029f8e": [1080, 1080],
  "3eb1a168": [1080, 1080],
  "be3149f3": [1080, 1080],
  "ea8b9d00": [2400, 1593],
  "5cc94bf8": [2400, 1593],
  "a5420c89": [1080, 1080],
  "ce96e121": [1080, 1080],
  "65ca762a": [2400, 1593],
  "0186ccc4": [1080, 1080],
  "074431b7": [1080, 1350],
  "674870c2": [2400, 1593],
  "3ed1ac20": [2400, 1593],
  "23df728f": [2400, 1594],
  "acc2768a": [2400, 1593],
  "c204bf34": [2400, 1594],
  "fce62083": [2400, 1594],
  "ecec0902": [1080, 1080],
  "e33edbda": [2400, 1594],
  "f185deec": [1080, 1080],
  "29632188": [1080, 1080],
  "41a1359f": [1080, 1350],
  "7336f6af": [1080, 1080],
  "56804c04": [1080, 1080],
  "0c826148": [1080, 1080],
  "dacaf7ed": [1080, 1080],
  "258732a4": [1080, 1080],
  "ee744aeb": [2400, 1600],
  "f962c705": [1080, 1080],
  "7817b43f": [2400, 1594],
  "5e8fd69e": [1080, 1080],
  "4dd358c5": [1080, 1080],
  "77dbb717": [2400, 1593],
  "d9c40a5f": [2400, 1593],
  "e7546373": [1080, 1080],
  "b7ce267c": [1080, 1080],
  "09387337": [2400, 1594],
  "2aad0a4e": [2400, 1600],
  "b691205c": [2400, 1594],
  "baff00a9": [1080, 1080],
  "9b151399": [2400, 1593],
  "aaa6106c": [1080, 1080],
  "250d8eb5": [1080, 1080],
  "8d3d22a1": [2400, 3000],
  "08261505": [2400, 1593],
  "fb794780": [2400, 1600],
  "1d44dcd8": [2143, 3000],
  "4d9bece3": [2400, 1593],
  "e886942f": [2400, 3000],
  "29934bed": [2400, 1726],
  "68bdccd2": [1080, 1080],
  "7099fe0b": [2400, 1593],
  "20573c45": [1080, 1080],
  "a12e0fdc": [1080, 1080],
  "6059fc58": [1080, 1080],
  "839a6f54": [1080, 1080],
  "71995bc7": [2400, 1600],
  "7df2de05": [2400, 1600],
  "10581abc": [1080, 1080],
  "5820bfd3": [2400, 1593],
  "387ee596": [1080, 1350],
  "e1f84461": [1080, 1350],
  "f88f7557": [1080, 1080],
  "b47e7ae2": [2400, 1726],
  "91a737aa": [1080, 1080],
  "0b792b77": [2400, 1600],
  "6795a9c5": [2400, 1600],
  "6e48da6d": [2400, 1594],
};
